import { z } from "zod";
import { ContractTypeSchema } from "./ContractType";
import { RequestContractVehiclesDtoSchema } from "./RequestContractVehiclesDto";

export const RequestPoistkaDtoSchema = z.object({
    product: z.string().nullish(),
    productId: z.number(),
    odvetvieId: z.number(),
    id: z.number(),
    stavPZ: z.string().nullish(),
    isGroupContract: z.boolean(),
    stavToShow: z.string().nullish(), // We fill this in the FE
    type: ContractTypeSchema.nullish(), // We fill this in the FE
    titleToShow: z.string().nullish(), // We fill this in the FE
    vehicles: z.array(RequestContractVehiclesDtoSchema).nullish(),
});

export type RequestPoistkaDto = z.infer<typeof RequestPoistkaDtoSchema>;